document.addEventListener("DOMContentLoaded", function () {
  /**
   * Contact form submissions to Google Sheet
   */
  const form = document.querySelector('form[action="/contact#contact_form"]');

  if (!form) return;

  form.addEventListener("submit", function () {
    const payload = {
      firstName: form.querySelector('[name="contact[first_name]"]')?.value || "",
      lastName: form.querySelector('[name="contact[last_name]"]')?.value || "",
      email: form.querySelector('[name="contact[email]"]')?.value || "",
      message: form.querySelector('[name="contact[body]"]')?.value || "",
    };

    fetch("https://script.google.com/macros/s/AKfycbyLpP4TP0HTdcWazsyozvxgnJSMH4b_IO0qVvFR8D7DtctKTwre_It_K6yTOqFzhK1IaQ/exec", {
      method: "POST",
      mode: "no-cors",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(payload),
    });
  });
});
